import React, { ReactElement, useEffect, useState } from "react";
import useAuthState from "../auth/useAuthState";
import useAccommodationState from "../accommodation/useAccommodationState.ts";
import { SyncCheckByAccommodation } from "./SyncCheckByAccommodation.tsx";
//interface SyncCheckListInterface {}

function SyncCheckList() {
    const [item, setItem] = useState<ReactElement[] | null>(null);
    const { token, getToken } = useAuthState();
    const { accommodations, accommodations_updated_at, getAccommodationList } =
        useAccommodationState();
    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (token) {
            getAccommodationList(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        if (accommodations && token) {
            setItem(
                accommodations.map((accommodation) => {
                    return (
                        <SyncCheckByAccommodation
                            key={"check_log_" + accommodation.id}
                            token={token}
                            accommodation_id={accommodation.id}
                        />
                    );
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accommodations_updated_at]);

    return (
        <div>
            <div className="toggle-pannel-header">
                <div className="toggle-title">同期チェックエラー</div>
            </div>
            <table className="w-full font-size-12 border-collapse border border-gray-light">
                <thead>
                    <tr className="bg-gray-light ">
                        <th className="w-80 p-10 border font-weight-normal ">
                            宿泊施設
                        </th>
                        <th className="p-10 border font-weight-normal ">
                            年月
                        </th>

                        <th className="p-10 border font-weight-normal ">
                            部屋
                        </th>
                        <th className="p-10 border font-weight-normal ">
                            チェック時間
                        </th>
                        <th className="p-10 border font-weight-normal ">
                            エラー日
                        </th>
                        <th className="p-10 border font-weight-normal ">
                            再チェック
                        </th>
                    </tr>
                </thead>
                <tbody>{item}</tbody>
            </table>
        </div>
    );
}
export default SyncCheckList;
